import PropTypes from 'prop-types'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

import {
  FromPrice,
  Installments,
  UnavailableProductMessage,
  ServicesBadge
} from './components'
import * as S from './styled'

const PriceTag = ({
  isAssistedSale,
  isBlackWeekend,
  isPromotional,
  hidePrice,
  isSoldOut,
  toPrice,
  regionPrice,
  fromPrice,
  discount,
  unit,
  installments,
  brandedInstallments,
  shopName,
  hasCrossServices = false,
  isServicesEnabled,
  packagingUnit,
  packagingPackaging,
  packagingLabel,
  packagingPriceIntegers,
  packagingPriceDecimals
}) => {
  const isLeroyStore = shopName === 'Leroy Merlin'
  const shouldRenderCrossServicesBadge = isServicesEnabled && hasCrossServices && isLeroyStore

  if (hidePrice || isSoldOut) {
    return (
      <S.PriceTag isUnavailable>
        <UnavailableProductMessage
          isAssistedSale={isAssistedSale}
          hidePrice={hidePrice}
        />
      </S.PriceTag>
    )
  }

  return (
    <S.PriceTag isBlackWeekend={isBlackWeekend} isPromotional={isPromotional}>
      <S.ToPriceContainer>
        <S.Container>
          <div>
            <S.ToPriceInteger>R$ {toPrice.integers}</S.ToPriceInteger>
            <span>,{toPrice.decimals} / {unit}</span>
          </div>

          {discount > 0 && <S.Discount>-{discount}%</S.Discount>}
        </S.Container>
      </S.ToPriceContainer>

      <S.Container>
        {packagingPackaging && (
          <S.PackagingPrice>
            <Text as="strong" bold noMargin>
              R${packagingPriceIntegers},{packagingPriceDecimals} / {packagingLabel}{' '}
            </Text>

            <S.Dot />

            <Text as="span" noMargin>
              {' '}cada {packagingLabel} possui {packagingPackaging.replace('.', ',')}{packagingUnit}
            </Text>
          </S.PackagingPrice>
        )}
      </S.Container>

      <S.Container>
        <div>
          <FromPrice
            isBlackWeekend={isBlackWeekend}
            price={regionPrice}
            unit={unit}
          />
          <FromPrice
            isBlackWeekend={isBlackWeekend}
            price={fromPrice}
            unit={unit}
          />

          <Installments
            isBlackWeekend={isBlackWeekend}
            installments={installments}
          />
          <Installments
            isBlackWeekend={isBlackWeekend}
            installments={brandedInstallments}
            isBranded
          />

          <S.ShopName as="span" size="kilo" noMargin>
            Vendido e entregue por <span data-seller-selected>{shopName}</span>
          </S.ShopName>
        </div>

        {shouldRenderCrossServicesBadge && (
          <S.Badge>
            <ServicesBadge />
          </S.Badge>
        )}
      </S.Container>
    </S.PriceTag>
  )
}

PriceTag.propTypes = {
  isAssistedSale: PropTypes.bool,
  isBlackWeekend: PropTypes.bool,
  isPromotional: PropTypes.bool,
  hidePrice: PropTypes.bool,
  isSoldOut: PropTypes.bool,
  toPrice: PropTypes.shape({
    decimals: PropTypes.string,
    integers: PropTypes.string
  }),
  regionPrice: PropTypes.shape({
    decimals: PropTypes.string,
    integers: PropTypes.string
  }),
  fromPrice: PropTypes.shape({
    decimals: PropTypes.string,
    integers: PropTypes.string
  }),
  discount: PropTypes.number,
  unit: PropTypes.string,
  installments: PropTypes.shape({
    amount: PropTypes.number,
    value: PropTypes.string
  }),
  brandedInstallments: PropTypes.shape({
    amount: PropTypes.number,
    value: PropTypes.string
  }),
  shopName: PropTypes.string.isRequired,
  hasCrossServices: PropTypes.bool.isRequired,
  isServicesEnabled: PropTypes.bool.isRequired
}

export default PriceTag
